<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <!--ヘッダーにmax-width1920がいらない時はここを削除。対応する</div>も一緒に-->
      <div class="m-width1920">
        <div class="d-flex align-items-center">
          <!--ここまで↑-->
          <a class="navbar-brand" href="/">
            <img
              class="navbar-logo"
              src="@/assets/img/logo/treasure_logo.png"
              alt="野球グラブのオーダーメイドシミュレーション | Treasure ロゴ"
            />
          </a>
          <div class="nav-link">
            特定商取引法に基づく表記
          </div>
        </div>
      </div>
    </nav>
    <!--固定ヘッダー-->

    <div class="container mt-5 confirmation-main text-color-fff">
      <h2 class="text-center">特定商取引法に基づく表記</h2>
      <p class="mt-5">
        特定商取引法に基づき、以下の通り表記いたします。
      </p>

      <div class="mt-5">
        <h5 class="mt-5">1. 販売業者名</h5>
        <p>有限会社間瀬土木</p>

        <h5 class="mt-5">2. 運営責任者</h5>
        <p>間瀬慎一</p>

        <h5 class="mt-5">3. 所在地</h5>
        <p>請求があった場合には遅滞なく開示いたします。</p>

        <h5 class="mt-5">4. 電話番号</h5>
        <p>
          請求があった場合には遅滞なく開示いたします。
        </p>

        <h5 class="mt-5">5. メールアドレス</h5>
        <p>
          {{ mailAddress }}
        </p>

        <h5 class="mt-5">6. お問い合わせ</h5>
        <p>
          上記メールアドレスよりご連絡ください。
        </p>

        <h5 class="mt-5">7. 商品の販売価格</h5>
        <p>
          硬式用グラブ：77,000円（税込）<br />
          ※上記は基本価格です。選択する仕様・オプション（刺繍、カラー変更等）により価格が加算されます。
        </p>

        <h5 class="mt-5">8. 商品代金以外の必要料金</h5>
        <p>
          送料はお届け先地域・配送方法に応じて別途発生いたします。<br />
          送料はご注文内容確認後にお見積りし、ご案内いたします。<br />
          <br />
          なお、送料を含む最終金額をご確認いただいた後に正式な受注手続きを行います。<br />
          <br />
          銀行振込でお支払いの場合、振込手数料はお客様のご負担となります。
        </p>

        <h5 class="mt-5">9. 消費税について</h5>
        <p>表示価格は消費税（10%）を含んだ金額です。</p>

        <h5 class="mt-5">10. お支払い方法</h5>
        <p>銀行振込</p>

        <h5 class="mt-5">11. お支払い期限</h5>
        <p>
          ご注文確定後、1週間以内にお振込をお願いいたします。1週間以内にお支払いが確認できない場合、ご注文をキャンセルさせていただく場合があります。
        </p>

        <h5 class="mt-5">12. 商品の引渡し時期</h5>
        <p>
          ご注文確定後、通常6ヶ月程度でのお届けとなります。受注状況により納期が前後する場合があります。発送準備が出来次第、メールにてご案内いたします。
        </p>

        <h5 class="mt-5">13. 返品・交換・キャンセルについて</h5>
        <p>
          お客様のご注文内容に応じて製作するオーダーメイド商品のため、お客様のご都合による返品・交換・キャンセルはお受けできません。お届けした商品に汚損・破損等の不良があった場合は、良品との交換にて対応いたします。
        </p>

        <div class="mt-5 text-center form-row mt-4 form__btn_gap">
          <div class="col">
            <button
              type="button"
              class="w-50 form-btn-block form-btn-secondary btn btn-block"
              @click="$router.back()"
            >
              戻る
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  p,
  li {
    font-size: 14px;
  }
  .tokushoho-link {
    color: #fff;
    text-decoration: underline;
  }
</style>

<script>
export default {
  computed: {
    mailAddress() {
      return ["s.mase", "ireiza.jp"].join("@");
    },
  },
};
</script>
